import { LocalDate } from 'src/utilities/local-date.js';

import type { UpdateStatus } from '../../library/lists/updateStatus';
import type { BaseTemplateItem } from './base-template-item';

export function calculateUpdateStatus<T extends BaseTemplateItem>(item: T, today: LocalDate): UpdateStatus {
  if (
    item.templateDeleted &&
    (!item.templateDeclined ||
      LocalDate.fromString(item.templateDeclined).isBefore(LocalDate.fromString(item.templateDeleted)))
  ) {
    return 'templateDeleted';
  } else if (
    item.hasTemplateUpdate &&
    (!item.templateDeclined ||
      LocalDate.fromString(item.templateDeclined).isBefore(LocalDate.fromString(item.templateUpdated)))
  ) {
    return 'templateUpdated';
  } else if (
    item.contentLastModified &&
    item.contentLastModified !== '' &&
    today.minusDays(30).isBefore(LocalDate.fromString(item.contentLastModified))
  ) {
    return 'documentUpdated';
  }

  return 'none';
}
